// How strong a new password looks while it is typed: length first (the API asks for 12+), then a mix of
// letters, digits and signs. A hint only; the API decides.
import { PASSWORD_MIN } from '@/api/schemas'

const LEVELS = [
  { word: 'Too short', bar: 'bg-red-500', width: 'w-1/4' },
  { word: 'Weak', bar: 'bg-amber-500', width: 'w-2/4' },
  { word: 'Good', bar: 'bg-primary', width: 'w-3/4' },
  { word: 'Strong', bar: 'bg-emerald-600', width: 'w-full' },
]

export function passwordLevel(password: string): number {
  if (password.length < PASSWORD_MIN) return 0
  const kinds = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((kind) => kind.test(password)).length
  if (password.length >= 16 && kinds >= 3) return 3
  return kinds >= 2 ? 2 : 1
}

export function PasswordStrength({ password }: { password: string }) {
  if (!password) return null
  const level = LEVELS[passwordLevel(password)]!
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="h-1.5 w-full rounded bg-slate-200 dark:bg-slate-700">
        <div className={`h-1.5 rounded ${level.bar} ${level.width}`} />
      </div>
      <p className="help mt-1">
        {level.word}
        {password.length < PASSWORD_MIN && ` · ${PASSWORD_MIN - password.length} more characters`}
      </p>
    </div>
  )
}
